export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* subtle editorial grid backdrop */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-secondary-100/40 via-background-50 to-background-50"></div>

      <div className="relative mx-auto w-full max-w-6xl px-4 pb-14 pt-24 md:px-6 md:pb-20 md:pt-32">
        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-12">
          {/* left: editorial text column */}
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-verified-badge-fill mr-1"></i>官方发布
              </span>
              <span className="text-xs tracking-[0.3em] text-foreground-500">
                第 2026 · 09 期
              </span>
            </div>

            <h1 className="mt-6 font-heading text-4xl font-bold leading-tight text-foreground-950 md:text-5xl">
              吃瓜官网
              <span className="mt-1 block text-foreground-700">
                官方渠道 · 一站直达
              </span>
            </h1>

            <p className="mt-5 text-[15px] leading-relaxed text-foreground-700">
              这里是吃瓜官网的官方入口页。无论是想核实吃瓜官网官方渠道、联络吃瓜官网客服，
              还是有内容、品牌层面的吃瓜官网合作与商务意向，都可以从这里找到对的人、
              走对的路。内容资讯与官方服务，皆循此门而入。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#channels"
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                进入官方渠道
                <i className="ri-arrow-right-line ml-1.5 align-middle"></i>
              </a>
              <a
                href="#business"
                className="whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-6 py-3 text-center text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                预约商务对接
              </a>
            </div>

            {/* mini stats strip */}
            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-300/60 pt-6">
              {[
                { n: "20+", t: "官方栏目" },
                { n: "3.8万", t: "每日新增资讯" },
                { n: "100+", t: "商务伙伴合作" },
              ].map((s) => (
                <div key={s.t}>
                  <dt className="sr-only">{s.t}</dt>
                  <dd className="font-heading text-2xl font-bold text-foreground-950">
                    {s.n}
                  </dd>
                  <dd className="mt-1 text-xs text-foreground-500">{s.t}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* right: editorial cover image (facing spread) */}
          <div className="lg:col-span-6">
            <figure className="group relative">
              <div className="absolute -left-3 -top-3 hidden h-full w-full rounded-lg border border-primary-200 md:block"></div>
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=editorial%20magazine%20flatlay%20of%20a%20stack%20of%20open%20newspapers%20and%20warm%20paper%20prints%20on%20a%20soft%20cream%20desk%2C%20a%20small%20watermelon%20slice%20as%20a%20playful%20accent%2C%20red%20news%20tape%20details%2C%20muted%20ink%20tones%2C%20premium%20minimal%20studio%20lighting%2C%20gentle%20soft%20shadows%2C%20editorial%20print%20aesthetic&width=1200&height=900&seq=chigua-hero-x1&orientation=landscape"
                  alt="吃瓜官网官方栏目资讯合集 杂志排版视觉"
                  title="吃瓜官网官方栏目资讯合集"
                  className="h-[280px] w-full object-cover md:h-[430px]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                <figcaption className="absolute bottom-0 left-0 right-0 p-5">
                  <span className="text-xs tracking-[0.25em] text-background-100">
                    COLLECTION · 栏目合集
                  </span>
                  <p className="mt-1 font-heading text-lg font-semibold text-background-50">
                    一张入口，翻遍吃瓜官网的全部看板
                  </p>
                </figcaption>
              </div>
              {/* issue badge */}
              <div className="absolute right-4 top-4 flex flex-col items-center rounded-md bg-accent-500 px-3 py-2 text-accent-950 shadow-sm">
                <span className="font-heading text-xl font-bold leading-none">9</span>
                <span className="mt-0.5 text-[10px] font-medium">月号</span>
              </div>
            </figure>
          </div>
        </div>
      </div>
    </section>
  );
}